import { format } from '@react-input/mask'
import * as Flags from 'country-flag-icons/react/3x2'

import {
  EMPTY_STRING,
  PHONE_INTERNATIONAL_FORMAT_SYMBOL,
} from '../../constants/common'
import { isValueStringType } from '../../utils/common'

import {
  PHONE_COUNTRIES,
  PHONE_MASK_REPLACEMENT,
  PHONE_PINNED_COUNTRIES_COUNT,
} from './Phone.constants'

function getCountryEnglishName(item) {
  return item[0]
}

export function getCountryName(item, displayNames) {
  return (
    displayNames?.of(getCountryValue(item).toUpperCase()) ??
    getCountryEnglishName(item)
  )
}

export function getCountryValue(item) {
  return item[2]
}

export function getCountryPhone(item) {
  return item[3]
}

export function getCountryPhoneMask(item) {
  return item[4]
}

export function getPhoneCountryDisplayNames(locale) {
  try {
    return new Intl.DisplayNames([locale], { fallback: 'none', type: 'region' })
  } catch {
    return null
  }
}

export function toCountrySelectItem(item, displayNames) {
  // eslint-disable-next-line import-x/namespace
  const Flag = Flags[getCountryValue(item).toUpperCase()]

  return {
    Icon: Flag,
    label: getCountryName(item, displayNames),
    mask: getCountryPhoneMask(item),
    phoneCode: getCountryPhone(item),
    value: getCountryValue(item),
  }
}

export function getPhoneCountryOptions({ displayNames, locale }) {
  const options = PHONE_COUNTRIES.map(item =>
    toCountrySelectItem(item, displayNames)
  )

  return options
    .slice(0, PHONE_PINNED_COUNTRIES_COUNT)
    .concat(
      options
        .slice(PHONE_PINNED_COUNTRIES_COUNT)
        .sort((a, b) => a.label.localeCompare(b.label, locale))
    )
}

export function parsePhoneValue(value, displayNames) {
  if (!isValueStringType(value) || !value) {
    return null
  }

  const matchedCountry = PHONE_COUNTRIES.find(item =>
    value.startsWith(getCountryPhone(item))
  )

  if (!matchedCountry) {
    return null
  }

  const country = toCountrySelectItem(matchedCountry, displayNames)
  const rawDigits = value.slice(country.phoneCode.length)
  const inputValue = format(rawDigits, {
    mask: country.mask,
    replacement: PHONE_MASK_REPLACEMENT,
  })

  return { country, inputValue }
}

export function getPhoneDisplayValue(value) {
  const parsed = parsePhoneValue(
    value?.replace(PHONE_INTERNATIONAL_FORMAT_SYMBOL, EMPTY_STRING)
  )

  if (!parsed) {
    return value ?? EMPTY_STRING
  }

  return `${PHONE_INTERNATIONAL_FORMAT_SYMBOL}${parsed.country.phoneCode} ${parsed.inputValue}`
}
